import { getRoutes } from '@ui-framework/index';
import AuthorizationWrapper, {
  authFnForMaintenancePages,
  authFnAllowOnlyAdminImplementationManager,
} from '@product-framework/components/AuthorizationWrapper';
import ServiceJobFormEdit from './pages/edit/index';
import ServiceJobFormCreate from './pages/create/index';
import ServiceJobFormList from './pages/list/index';
import schema from './schemas/routes.json';
import ErrorPage, { ERROR_PAGE_TYPE } from '../ErrorPage';

import ServiceJobFormFormStore from './store/index';

const Pages = ProtectedRoute => ({
  ServiceJobFormEdit: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={ServiceJobFormEdit}
      AuthorizationWrapper={AuthorizationWrapper}
      AuthorizationWrapperProps={{
        authorizationFn: [authFnForMaintenancePages],
      }}
    />
  ),
  ServiceJobFormCreate: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={ServiceJobFormCreate}
      AuthorizationWrapper={AuthorizationWrapper}
      AuthorizationWrapperProps={{
        authorizationFn: [authFnAllowOnlyAdminImplementationManager],
      }}
    />
  ),
  ServiceJobFormList: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={ServiceJobFormList}
      AuthorizationWrapper={AuthorizationWrapper}
      AuthorizationWrapperProps={{
        authorizationFn: [authFnForMaintenancePages],
      }}
    />
  ),
});

const routes = ({ ProtectedRoute, BubbleRouteError }) =>
  getRoutes({
    schema,
    ProtectedRoute,
    BubbleRouteError,
    Pages: Pages(ProtectedRoute),
  });

const stores = rootStore => [
  { servicejobformFormStore: new ServiceJobFormFormStore(rootStore) },
];

export {
  ServiceJobFormEdit,
  ServiceJobFormCreate,
  ServiceJobFormList,
  routes,
  stores,
};
